import { isNumber } from "lodash";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model["executingStages"]): string => {
	const delay = item?.delayed?.data?.delay;

	if (isNumber(delay) && delay > 0) {
		return `${(delay / 60_000).toFixed(0)} мин.`;
	}

	return "";
};

export default cellProcessing;
